import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { required, alphaName, notEmpty } from '../../../../utils/validate';
import { toAlphabets, toNumber } from '../../../../utils/formatters';
import Input from '../../../Forms/Input/input';
import { submitInvitationCode, toggleNoInvitationDialog } from '../../../../actions/loanApplicationActions';
import FeatureToggle from '../../../FeatureToggle/feature.toggle';
import PropTypes from 'prop-types';

export const LandingForm = (props) => {
  const { handleSubmit, submitInvitationCode, toggleNoInvitationDialog, submitSucceeded } = props;
  if (submitSucceeded) {
    return <Redirect push to="/apply/loan/check-your-rate"/>;
  }

  return (
    <form autoComplete="off" noValidate="novalidate" onSubmit={handleSubmit(submitInvitationCode)} className="cobranded-page-landing-form w-100">
      <div className="row align-items-center landing-form-row">
        <div className="col-sm-12 col-md-4">
          <Field
            name="invitationCode"
            label="Invitation code"
            component={Input}
            type="text"
            validate={[required]}
            required={true}
            normalize={toNumber}
            styles={ { input: ["form-control-lg", "border-0", "w-100"] } }
          />
        </div>
        <div className="col-sm-12 col-md-4">
          <Field
            name="lastName"
            label="Last name"
            component={Input}
            type="text"
            validate={[required, alphaName, notEmpty]}
            required={true}
            normalize={toAlphabets}
            styles={ { input: ["form-control-lg", "border-0", "w-100"] } }
          />
        </div>

        <div className="col-sm-12 col-md-4 mb-auto continue-button-div">
          <button type="submit" formNoValidate="true" className="w-100 btn bcus-btn bottom-shadow my-2">Continue</button>
          <FeatureToggle key="toggleOff" featureName="cl_block_open_market" showWhenFeatureToggleOff={true}>
            <Link to="/" data-track="app-links" className="w-100 text-center invitation-code-link">No invitation code?</Link>
          </FeatureToggle>
          <FeatureToggle key="toggleOn" featureName="cl_block_open_market">
            <Link to="/clapply/cl/CLLanding.action/invitation/american" data-track="app-links" onClick={toggleNoInvitationDialog} className="w-100 text-center invitation-code-link">No invitation code?</Link>
          </FeatureToggle>
        </div>
      </div>
    </form>);
};

LandingForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitSucceeded: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = { submitInvitationCode, toggleNoInvitationDialog };
export const ConnectedLandingForm = connect(mapStateToProps, mapDispatchToProps)(LandingForm);

export default reduxForm({
  form: 'cobrandedLanding'
})(ConnectedLandingForm);
